module.exports = __webpack_public_path__ + "media/images/pic/saska/hero-teenagers-039e5c1f1fdeac99c0c5906b857290f9.svg";